import React, { useState, useEffect, useRef } from 'react';

const Banner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const autoPlayRef = useRef(null);

  const banners = [
    { id: 1, image: '/banner.png' },
  ];

  useEffect(() => {
    autoPlayRef.current = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % banners.length);
    }, 5000);

    return () => clearInterval(autoPlayRef.current);
  }, [banners.length]);

  return (
    <section className="relative w-full overflow-hidden bg-black">
      <div
        className="
          relative w-full 
          h-auto
          max-w-[1920px] 
          mx-auto
        "
      >
        {banners.map((banner, index) => (
          <div
            key={banner.id}
            className={`relative w-full transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            {/* Mobile View - object-contain (full image visible) */}
            <div className="block md:hidden">
              <img
                src={banner.image}
                alt={`Banner ${banner.id}`}
                className="w-full h-auto object-contain"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = `
                    <div class="w-full min-h-[300px] flex items-center justify-center bg-gradient-to-r from-green-600 to-green-700">
                      <div class="text-white text-center px-6">
                        <h1 class="text-2xl font-bold mb-2">
                          Breathe Easy Hospital
                        </h1>
                        <p class="text-base">
                          Expert Respiratory Care
                        </p>
                      </div>
                    </div>
                  `;
                }}
              />
            </div>

            {/* Desktop View - object-cover (full width banner) */}
            <div className="hidden md:block">
              <img
                src={banner.image}
                alt={`Banner ${banner.id}`}
                className="w-full h-[500px] lg:h-[600px] xl:h-[700px] object-cover object-center"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = `
                    <div class="w-full h-[500px] lg:h-[600px] xl:h-[700px] flex items-center justify-center bg-gradient-to-r from-green-600 to-green-700">
                      <div class="text-white text-center px-6">
                        <h1 class="text-4xl font-bold mb-4">
                          Breathe Easy Hospital
                        </h1>
                        <p class="text-xl">
                          Expert Respiratory Care
                        </p>
                      </div>
                    </div>
                  `;
                }}
              />
            </div>
          </div>
        ))}

        <div
          className="
            absolute 
            bottom-3 md:bottom-5 lg:bottom-6
            left-1/2 -translate-x-1/2 
            flex gap-2 
            z-10
          "
        >
          {banners.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`rounded-full transition-all duration-300 ${
                index === currentSlide
                  ? 'bg-white w-6 h-2'
                  : 'bg-white/70 w-2 h-2 hover:bg-white'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Banner;
